import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef, createContext } from 'react';
import { useContextProps, useRenderProps } from '../../utils/index.esm.js';

var OverlayArrowContext = /*#__PURE__*/createContext({
  placement: 'bottom'
});
function OverlayArrow(props, ref) {
  var _useContextProps = useContextProps(props, ref, OverlayArrowContext);
  var _useContextProps2 = _slicedToArray(_useContextProps, 2);
  props = _useContextProps2[0];
  ref = _useContextProps2[1];
  var placement = props.placement;
  var style = {
    position: 'absolute',
    transform: placement === 'top' || placement === 'bottom' ? 'translateX(-50%)' : 'translateY(-50%)'
  };
  if (placement != null) {
    style[placement] = '100%';
  }
  var renderProps = useRenderProps(_objectSpread2(_objectSpread2({}, props), {}, {
    defaultClassName: 'react-aria-OverlayArrow',
    values: {
      placement: placement
    }
  }));
  // remove undefined values from renderProps.style object so that it can be
  // spread merged with the other style object
  if (renderProps.style) {
    Object.keys(renderProps.style).forEach(function (key) {
      return renderProps.style[key] === undefined && delete renderProps.style[key];
    });
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({}, props, renderProps, {
    // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
    style: _objectSpread2(_objectSpread2({}, style), renderProps.style),
    ref: ref,
    "data-placement": placement
  }));
}

/**
 * An OverlayArrow renders a custom arrow element relative to an overlay element
 * such as a popover or tooltip such that it aligns with a trigger element.
 */
var _OverlayArrow = /*#__PURE__*/forwardRef(OverlayArrow);

export { _OverlayArrow as OverlayArrow, OverlayArrowContext };
//# sourceMappingURL=overlay-arrow.esm.js.map
